import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

function GreenCheckBadge({ show, children }) {
  if (!show) return <>{children}</>;

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="sp-tooltip">
          The property is either partly or wholly separate property of a party.
        </Tooltip>
      }
    >
      <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
        <span style={{ color: "green", fontSize: "14px" }}>SP</span>
      </div>
    </OverlayTrigger>
  );
}

export default GreenCheckBadge;